import api from './api';

export const bidangService = {
    // PUBLIC
    getAll: async () => {
        try {
            const response = await api.get('/bidangs');
            return { success: true, data: response.data?.data || response.data || [] };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data bidang' };
        }
    },

    // ADMIN
    create: async (payload) => {
        try {
            const response = await api.post('/bidangs', payload);
            return { success: true, data: response.data?.data || response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat bidang',
            };
        }
    },

    update: async (id, payload) => {
        try {
            const response = await api.put(`/bidangs/${id}`, payload);
            return { success: true, data: response.data?.data || response.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal mengupdate bidang' };
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/bidangs/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus bidang' };
        }
    },
};